import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeHomeComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
